import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "buttonText", "buttonIcon" ]

  connect() {
    this.updateToggleUI()
    // Listen to prefers-color-scheme changes if system theme is selected
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    this.mediaQueryListener = () => {
      if (this.currentTheme === 'system') {
        this.applyTheme()
      }
    }
    this.mediaQuery.addEventListener('change', this.mediaQueryListener)
  }

  disconnect() {
    this.mediaQuery.removeEventListener('change', this.mediaQueryListener)
  }

  cycle() {
    const themes = ['system', 'light', 'dark']
    const nextIndex = (themes.indexOf(this.currentTheme) + 1) % themes.length
    const nextTheme = themes[nextIndex]

    localStorage.setItem('theme', nextTheme)
    this.applyTheme()
  }

  applyTheme() {
    const theme = this.currentTheme
    const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)

    if (isDark) {
      document.documentElement.classList.add('dark')
      document.documentElement.style.colorScheme = 'dark'
    } else {
      document.documentElement.classList.remove('dark')
      document.documentElement.style.colorScheme = 'light'
    }

    // Update theme-color meta tag if present
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', isDark ? '#14120f' : '#fcfbf9')
    }

    // Force Safari repaint/re-render to ensure color changes propagate immediately
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    if (isSafari) {
      const _ = document.documentElement.offsetHeight
    }

    this.updateToggleUI()
  }

  updateToggleUI() {
    const theme = this.currentTheme
    
    // Set text
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = theme.charAt(0).toUpperCase() + theme.slice(1)
    }

    // Set icon
    if (this.hasButtonIconTarget) {
      let icon = "contrast"
      if (theme === "light") {
        icon = "light_mode"
      } else if (theme === "dark") {
        icon = "dark_mode"
      }
      this.buttonIconTarget.textContent = icon
    }
  }

  get currentTheme() {
    return localStorage.getItem('theme') || 'system'
  }
}
